export const DOCUMENT_AUTOMATION_DISMISS_MSG = 'Are you sure you want to delete this template?';
export const DELETE_DOCUMENT_TITLE = 'Delete Template';
